import type { RootState } from '@generalTypes/rootStateTypes';
import { loadPreviousVersion } from '@newStore/llinkid/llinkidActions';
import { selectPreviousVersionContent } from '@newStore/llinkid/llinkidSelectors';
import type { EditAsidePreviousVersion } from '@nodeTypeConfig/configTypes';
import { any } from 'prop-types';
import type React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getTitle } from '../../../../services/types';
import { useEditHref } from '../../../hooks/UseEditHref';
import SimpleInput from '../asideSimpleInput/SimpleInput';

const AsidePreviousVersion: React.FC<{ config: EditAsidePreviousVersion; readonly: boolean }> = ({
  config,
  readonly,
}) => {
  const dispatch = useDispatch();

  const currentEditingHref = useEditHref();

  const previousCurrs = useSelector((state: RootState) =>
    selectPreviousVersionContent(state, currentEditingHref),
  );

  useEffect(() => {
    if (currentEditingHref) {
      dispatch(loadPreviousVersion({ href: currentEditingHref }));
    }
  }, [dispatch, currentEditingHref]);

  const defaultValue = previousCurrs[0] ? getTitle(previousCurrs[0], { addIdentifier: true }) : '';

  return (
    <SimpleInput
      defaultValue={defaultValue}
      label={config.label}
      readOnly={readonly}
      onChange={(_value) => {}}
    />
  );
};

AsidePreviousVersion.displayName = 'AsidePreviousVersion';

export default AsidePreviousVersion;

AsidePreviousVersion.propTypes = {
  config: any,
  readonly: any,
};
